export const paginationDetails = (
  total: number,
  pageSize: number,
  currentPage: number
) => {
  const lastPage = Math.ceil(total / pageSize);
  const isLastPage = currentPage === lastPage;

  const from = (currentPage - 1) * pageSize + 1;
  const to = isLastPage ? total : currentPage * pageSize;

  const isMultiplePages = total > pageSize;
  const currentPageScope = isMultiplePages ? `${from}-${to} of ` : '';

  return `${currentPageScope}${total}`;
};
